module.exports = __webpack_public_path__ + "static/media/hot3.d26ce75d.png";